import { FC } from 'react';
import { Button } from '@sravni/react-design-system';
import getConfig from 'next/config';
import { addQueryParams } from '../../../../helpers/addQueryParams';
import { FORM_FIELDS } from '../../../../constants';
import { Categories, EventType, useAnalytics } from '../../../hooks/analytics';
import { PERIOD_SOURCE, PURPOSE_SOURCE } from '../../../../constants/sources';
import { getQueryParams } from '../../../../helpers/getQueryParams';
import { DEFAULT_RATE } from './consts';

interface Props {
    landingData: FE.FormData;
}

export const CustomButton: FC<Props> = ({ landingData }) => {
    const { pushEvent } = useAnalytics();

    const click = () => {
        const selectionQuery = {
            ...getQueryParams(window.location.search),
            amount: landingData[FORM_FIELDS.AMOUNT],
            period: landingData[FORM_FIELDS.PERIOD],
            purpose: landingData[FORM_FIELDS.PURPOSE],
            skipLanding: 'true',
            after_calculator_auth: 'button',
        };

        const webPath = getConfig().publicRuntimeConfig.webPath;

        const selectionUrl = addQueryParams(`${webPath}/kredity/onlajn-zayavka-na-kredit/`, selectionQuery);

        const period = PERIOD_SOURCE.find((e) => e.value === landingData[FORM_FIELDS.PERIOD])?.name;
        const purpose = PURPOSE_SOURCE.find((e) => e.value === landingData[FORM_FIELDS.PURPOSE])?.name;

        pushEvent({
            event: EventType.mainEvent,
            eventCategory: Categories.Loan,
            eventAction: 'Переход к анкете',
            eventLabel: [
                'Войти Подбор',
                'Лендинг подбора',
                landingData[FORM_FIELDS.AMOUNT],
                period,
                purpose,
                DEFAULT_RATE,
            ].join('|'),
        });

        window.location.href = selectionUrl;
    };

    return (
        <Button onClick={click} size={60} variant={'primary'}>
            Продолжить
        </Button>
    );
};
